import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_CONDITION_FORM_REQUEST = `${
  app.NS
}account/save_condition_form_request`;
export const SAVE_CONDITION_FORM_REQUEST_ACTION = createAction(
  SAVE_CONDITION_FORM_REQUEST
);
const SAVE_CONDITION_FORM_SUCCESS = `${
  app.NS
}account/save_condition_form_success`;
export const SAVE_CONDITION_FORM_SUCCESS_ACTION = createAction(
  SAVE_CONDITION_FORM_SUCCESS
);
const SAVE_CONDITION_FORM_FAILURE = `${
  app.NS
}account/save_condition_form_failure`;
export const SAVE_CONDITION_FORM_FAILURE_ACTION = createAction(
  SAVE_CONDITION_FORM_FAILURE
);

export const saveConditionFormRequest = id => {
  const action = SAVE_CONDITION_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveConditionFormSuccess = user => {
  const action = SAVE_CONDITION_FORM_SUCCESS_ACTION(user);
  return action;
};

export const saveConditionFormFailure = error => {
  const action = SAVE_CONDITION_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/condition.js